import { atom } from "recoil";

export interface MfaRequiredModalState {
    visible: boolean;
    projectId?: string;
}

export const mfaRequiredModalState = atom<MfaRequiredModalState>({
    key: "MfaRequiredModalState",
    default: {
        visible: false
    }
});
